import { css } from '@emotion/react'
import { Color, Spacing, Theme, Typography } from '@opallabs/gem'

export const textareaOverrides = css({
  minBlockSize: 36,
  display: 'block',
  lineHeight: '18px',
  paddingInline: Spacing.S,
  width: '100%',
})

export const characterText = (theme: Theme) =>
  css({
    color: Color[theme]['Text/Secondary'],
    display: 'block',
    marginTop: Spacing.S,
    ...Typography.T300,
  })
